import localDb from '@util/localDb';

// 按模块的action, reducer整合体
const INCOME_INFO = 'INCOME_INFO';

export function saveIncomeInfo(params) {
  return dispatch => {
    localDb.set(INCOME_INFO, params);
    return dispatch({
      type: INCOME_INFO,
      data: params,
    });
  };
}

// Reducer
export function incomeInfo(state = {}, action) {
  switch (action.type) {
    case INCOME_INFO:
      return action.data;
    default:
      return localDb.get(INCOME_INFO);
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/income_info.js